module.exports = __webpack_public_path__ + "img/staff-icon.f2561263.svg";